import * as yup from 'yup';

const errorMessage = 'Vinsamlegast skiljið reitinn ekki eftir auðann';

export const DailyAllowanceFormValidation = yup.object().shape({
  expenseReportNumber: yup.string(),
  employeePersonnelNumber: yup.string(),
  costDateFrom: yup.string().required(errorMessage),
  costDateTo: yup.string().required(errorMessage),
  country: yup.string().nullable(),
  city: yup.string().nullable(),
  categoryName: yup.string().required(),
});
